<div class="container" (click)="onClicked()">
  <i *ngIf="checked" class="material-icons checked">check_box</i>
  <i *ngIf="!checked" class="material-icons unchecked">check_box_outline_blank</i>

  <div class="text-big-medium-grey24 content">
    <ng-content></ng-content>
  </div>
</div>
